export const getAllFolderItems = (folder) => folder.children.flatMap((item) => {
    if (item.previewType === 'folder') {
        return [item, ...getAllFolderItems(item)];
    }
    return item;
});
